import { BaseService } from './base.service'

export class PaymentSummaryService extends BaseService {
  static get entity () {
    return 'payments'
  }

  static get listUrl () {
    return 'Payment/PaymentSummary'
  }

  static get detailUrl () {
    return 'Payment/PaymentSummary'
  }

  static getPaymentInfo (contractNo, customerCode, amount) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`Payment/PaymentOnline/${contractNo}`, {
        customerCode: customerCode,
        amount: amount
      })
        .then(response => {
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static verifyPaymentResult (data) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post('Dashboard/PaymentOnlineResult', data)
        .then(response => {
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getConfirmedTermsOfPayment (contractNo, customerCode, amount) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('Dashboard/GetConfirmedTermsOfPayment')
        .then(response => {
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static updateGetConfirmedTermsOfPayment (contractNo, customerCode, amount) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('Dashboard/UpdateConfirmedTermsOfPayment')
        .then(response => {
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }
}
